import { Roles } from 'roles';
import moment from 'moment';
import _ from 'lodash';

import { Flights } from '../../flights/flights';
import { Montgolfieres } from '../../montgolfieres/montgolfieres';

export const organizer = new Roles.Role('organizer');

/*
 *	List Permissions
 *	Manage page access
 */
organizer.allow('alerts.list', true);
organizer.allow('calendar.list', true);
organizer.allow('orders.list', true);
organizer.allow('flights.list', true);
organizer.allow('flights-type.list', true);
organizer.allow('places.list', true);
organizer.allow('prices.list', true);
organizer.allow('promotions.list', true);
organizer.allow('options.list', true);
organizer.allow('users.list', true);
organizer.allow('montgolfieres.list', true);
organizer.allow('statistics.list', true);
organizer.allow('planifications.list', true);


/*
 *	Users
 */
/*organizer.allow('users.insert', (userId, doc) => {
	return _.indexOf(doc.roles, "god") == -1;
})*/;

organizer.deny('users.update', (userId, doc, fields, modifier) => {
	return (modifier &&
			modifier['$set'] &&
				modifier['$set']['roles'] &&
					_.indexOf(modifier['$set']['roles'], "god") !== -1);
});
organizer.allow('users.remove', (userId, doc) => {
	return _.indexOf(doc.roles, "god") == -1 && doc._id !== userId;
});

/*
 *	Montgolfieres
 */
organizer.allow('montgolfieres.insert', true);
organizer.allow('montgolfieres.update', true);
organizer.allow('montgolfieres.remove', false);

/*
 *  Flights
 */
organizer.allow('flights.insert', (userId, doc) => {
	/*if (moment().startOf('day').isAfter(moment(doc.date).startOf('day')))
		return false;

	//if (pilotId && Flights.findOne({ date: doc.date, period: doc.period, pilotId: doc.pilotId }))
	//	return false;

	const montgolfiere = Montgolfieres.findOne(doc.montgolfiereId);
	if ((doc.montgolfiereId && !montgolfiere) || (montgolfiere && !_.includes(montgolfiere.allowedPilots, doc.pilotId)))
		return false;

	if (doc.reservationIds && doc.reservationIds.length)
		return false;

	if (doc.status !== "preparing")
		return false;

	const projection = {
		$elemMatch: {
			startDate: {$lte: doc.date},
			endDate: {$gte: doc.date},
			isAvailable: true,
			period: doc.period
		}
	};*/

	return true;
});
organizer.allow('flights.update', false);
organizer.allow('flights.prepare', true);
organizer.allow('flights.prepare', (userId, doc) => {
	return doc.status == "preparing";
});
organizer.allow('flights.enclose', (userId, doc) => {
	return doc.status == "prepared" /* && moment().isAfter(moment(doc.date).startOf('day').add(doc.period == 'morning' ? 12 : 23, 'hours')) */;
});
organizer.allow('flights.remove', (userId, doc) => {
	return doc.status === 'preparing';
});

/*
 *  Lieux d'envols
 */
organizer.allow('places.insert', true);
organizer.allow('places.update', true);
organizer.allow('places.remove', false);

/*
 *  Reservations
 */
organizer.allow('reservations.insert', true);
organizer.allow('reservations.update', true);
organizer.allow('reservations.remove', true);

/*
 *  Alerts
 */
organizer.allow('alerts.insert', true);
organizer.allow('alerts.update', true);
organizer.allow('alerts.remove', true);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/users/roles/organizer.js
 **/